module.exports = __webpack_public_path__ + "img/_Large-Bevel-Attachment.6ab9752f.jpg";